import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=d2525a90"
import script from "./search.component.vue?vue&type=script&lang=ts"
export * from "./search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports